import { lazy, Suspense, type ReactNode } from "react";

import { SparkIcon } from "@/components/icons";
import { RequirePermission } from "@/components/RequirePermission";
import { ROUTES } from "@/config/routes";
import type { FeatureModule } from "@/types/feature";

const MomentumPage = lazy(() =>
  import("./MomentumPage").then((m) => ({ default: m.MomentumPage }))
);
const ClientMomentumDetailPage = lazy(() =>
  import("./ClientMomentumDetailPage").then((m) => ({ default: m.ClientMomentumDetailPage }))
);

function Loader() {
  return <div style={{ padding: 20, color: "var(--text-muted)", fontSize: 14 }}>Loading…</div>;
}

/** Gate a route element on feature.client-momentum.access (client mirror of the server). */
function guard(element: ReactNode): ReactNode {
  return (
    <RequirePermission perm="feature.client-momentum.access" redirectTo={ROUTES.overview}>
      <Suspense fallback={<Loader />}>{element}</Suspense>
    </RequirePermission>
  );
}

/**
 * Client Momentum registration. Gated on feature.client-momentum.access —
 * the shadow-run pilot model: seeded to no role but superadmin, granted
 * per-user to IOMs + the build owner from the access UI (client mirror of
 * the server gate).
 */
export const clientMomentumFeature: FeatureModule = {
  id: "client-momentum",
  navItems: [
    {
      id: "client-momentum",
      label: "Client Momentum",
      path: ROUTES.clientMomentum,
      icon: SparkIcon,
      requires: "feature.client-momentum.access",
    },
  ],
  routes: [
    { path: ROUTES.clientMomentum, element: guard(<MomentumPage />) },
    { path: ROUTES.clientMomentumClient, element: guard(<ClientMomentumDetailPage />) },
  ],
};
